import React from "react";
import { AnalyticsSessionParamsContextType } from "@pepdirect/v3/types";

export const AnalyticsSessionParamsContext =
  React.createContext<AnalyticsSessionParamsContextType>({
    analyticsSessionParams: {},
  });
